'use client';

import { storyblokEditable } from '@storyblok/react/rsc';
import { clsx } from 'clsx';
import { FC, useState } from 'react';
import { BannerCampaignStoryblok } from 'storyblok-types';
import { Icon, IconType } from 'atoms/Icon';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { useMediaQuery } from 'modules/mui/hooks';
import storage from 'modules/storage';
import { isValidDate } from 'modules/stroyblok/services';
import styles from 'src/client/components/pages/StoryBlok/BannerCampaign/styles.module.css';

export const BannerCampaign: FC<{ blok: BannerCampaignStoryblok }> = ({
  blok,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const CAMPAIGN_STORAGE_NAME = 'campaign_banner_hidden';

  const isValid = isValidDate(
    blok.start_date || '',
    blok.expiration_date || '',
  );

  const shouldBeVisible =
    isValid && storage.session.getItem(CAMPAIGN_STORAGE_NAME) !== 'true';

  const { isMobile } = useMediaQuery();

  const { image, mobileImage } = blok;

  const bannerImage = isMobile ? mobileImage : image;

  return !shouldBeVisible ? null : (
    <div
      {...storyblokEditable(blok)}
      className={clsx(styles.root, !isVisible && styles.hidden)}
    >
      <div className={styles.close} onClick={() => setIsVisible(false)}>
        <Icon className={styles.icon} type={IconType.close} />
      </div>
      <Link
        className={styles.link}
        href={blok.url || ''}
        onClick={() => storage.session.setItem(CAMPAIGN_STORAGE_NAME, 'true')}
      >
        <Image
          className={styles.image}
          src={bannerImage?.filename}
          alt={bannerImage?.alt}
        />
      </Link>
    </div>
  );
};
